import { create } from "zustand";

/**
 * Abas da faixa da lista de conversas (SA-1368): uma por `attendant_status`.
 * O valor da aba É o status, então a query de cada aba filtra por ele direto.
 */
export type StatusTabValue = "human" | "awaiting_human" | "ai";

/**
 * Lista ativa da tela de conversas: uma das abas da faixa ou Encerradas
 * (SA-1369, `closed`), que vem do sub-item do menu e não tem aba na faixa.
 */
export type TabValue = StatusTabValue | "closed";

type ChatsTabsState = {
  activeTab: TabValue;
  setActiveTab: (tab: TabValue) => void;
};

export const useChatsTabs = create<ChatsTabsState>((set) => ({
  activeTab: "human",
  setActiveTab: (tab) =>
    set((state) => ({
      ...state,
      activeTab: tab,
    })),
}));
